export default function IntroHero() {
  return (
    <section
      className="relative w-full min-h-[520px] md:min-h-[600px] flex items-end overflow-hidden"
      style={{ backgroundColor: '#0d2b24' }}
    >
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Professional%20Korean%20caregiver%20service%20company%20team%20group%20photo%20in%20modern%20bright%20office%20building%2C%20green%20and%20white%20corporate%20interior%2C%20warm%20professional%20atmosphere%2C%20wide%20angle%20shot%2C%20clean%20architecture%2C%20natural%20lighting%20from%20large%20windows%2C%20photorealistic%20high%20quality&width=1440&height=600&seq=kc_intro_hero1&orientation=landscape"
          alt="코리아케어러스 회사 소개"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0" style={{ background: 'linear-gradient(to right, rgba(13,43,36,0.92) 0%, rgba(13,43,36,0.7) 50%, rgba(13,43,36,0.4) 100%)' }}></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-6 pb-16 pt-32 w-full">
        <div className="max-w-xl">
          <div className="flex items-center gap-3 mb-5">
            <div className="w-8 h-px" style={{ backgroundColor: '#2E7D6B' }}></div>
            <span
              className="text-xs font-semibold tracking-widest uppercase px-3 py-1 rounded-full"
              style={{ backgroundColor: 'rgba(46,125,107,0.25)', color: '#6fcfb8' }}
            >
              ABOUT US
            </span>
          </div>
          <h1 className="text-4xl md:text-5xl font-bold text-white leading-tight mb-5">
            코리아케어러스<br />
            <span style={{ color: '#6fcfb8' }}>회사 소개</span>
          </h1>
          <p className="text-sm md:text-base leading-relaxed" style={{ color: 'rgba(255,255,255,0.65)' }}>
            간병 접수부터 보험 청구까지 원스톱으로 해결해 드리는<br />
            전문 간병 서비스 코리아케어러스를 소개합니다.
          </p>
        </div>
      </div>

      {/* Breadcrumb */}
      <div className="absolute bottom-0 right-0 left-0 z-10">
        <div className="max-w-7xl mx-auto px-6">
          <div className="flex items-center gap-2 py-3 border-t" style={{ borderColor: 'rgba(255,255,255,0.1)' }}>
            <a href="/" className="text-xs cursor-pointer transition-colors" style={{ color: 'rgba(255,255,255,0.4)' }}>홈</a>
            <i className="ri-arrow-right-s-line text-xs" style={{ color: 'rgba(255,255,255,0.25)' }}></i>
            <span className="text-xs" style={{ color: '#6fcfb8' }}>회사 소개</span>
          </div>
        </div>
      </div>
    </section>
  );
}
